import { css } from '@emotion/css';
import { cssVarV2 } from '@streamlain/theme/v2';

import { DEFAULT_COLUMN_TITLE_HEIGHT } from '../../../../consts';

export const columnHeaderContainer = css({
  display: 'block',
  backgroundColor: 'var(--streamlain-v2-layer-background-primary)',
  position: 'sticky',
  top: 0,
  zIndex: 20,
});

export const columnHeader = css({
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  height: `${DEFAULT_COLUMN_TITLE_HEIGHT}px`,
  overflow: 'hidden',
  boxSizing: 'border-box',
  userSelect: 'none',
  backgroundColor: 'var(--streamlain-v2-layer-background-primary)',
  '&::before, &::after': {
    content: '""',
    position: 'absolute',
    left: 0,
    right: 0,
    zIndex: 1,
    height: '1px',
    backgroundColor: cssVarV2.layer.insideBorder.border,
    pointerEvents: 'none',
  },
  '&::before': {
    top: 0,
  },
  '&::after': {
    bottom: 0,
  },
});

export const column = css({
  cursor: 'pointer',
  flex: '0 0 auto',
});

export const cell = css({
  userSelect: 'none',
});

export const headerAddColumnButton = css({
  boxSizing: 'border-box',
  height: `${DEFAULT_COLUMN_TITLE_HEIGHT}px`,
  margin: 0,
  backgroundColor: cssVarV2.layer.background.primary,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '40px',
  cursor: 'pointer',
  fontSize: '18px',
  lineHeight: 0,
  color: cssVarV2.icon.primary,
  flex: '0 0 auto',
  '&:hover': {
    backgroundColor: 'var(--streamlain-v2-layer-background-hoverOverlay)',
  },
});
